import React, { useEffect, useState } from 'react';
import { ConsigneeService } from 'services';
import { useStore } from 'hooks';
import Menu from 'components/menu';
import Table from 'components/table';
import Actions from 'components/table/actions';
import Modal from 'components/modal';
import ConsigneeCatalog from 'components/modal/consignee-catalog';
import { Input } from 'components/ui/form';
import styles from './consignee-catalog.module.scss';

const DEFAULT_LIMIT = 20;

const ConsigneeCatalogPage = () => {
  const { reload, setUser, setLoading, setReload } = useStore();
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(DEFAULT_LIMIT);
  const [searchQuery, setSearchQuery] = useState('');
  const [edit, setEdit] = useState(null);
  const [modal, setModal] = useState(false);
  const [items, setItems] = useState([]);
  const [count, setCount] = useState(0);

  useEffect(() => {
    let cancelled = false;

    async function fetchData() {
      setLoading(true);
      const params = { page, limit };
      if (searchQuery.trim()) {
        params.search = searchQuery.trim();
      }
      const response = await new ConsigneeService({ setUser }).getConsignees(params);
      setLoading(false);

      if (cancelled || !response) return;
      if (response.items != null) {
        setItems(response.items);
        setCount(response.count ?? 0);
      }
    }

    fetchData();
    return () => { cancelled = true; };
  }, [page, limit, searchQuery, reload, setUser, setLoading]);

  const onOpenModal = () => setModal(true);

  const onCloseModal = (isReload = false) => {
    setEdit(null);
    setModal(false);
    if (isReload) {
      setReload();
    }
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setPage(0);
  };

  const cells = [{
    name: 'Грузополучатель',
    renderField: 'name',
  }, {
    name: 'Адрес грузо-ля',
    renderField: 'address',
  }, {
    name: 'УНП',
    renderField: 'inn',
  }, {
    name: 'ЖД код грузо-ля',
    renderField: 'codeGd',
  }, {
    name: 'Код внутренний',
    renderField: 'code',
  }, {
    name: '',
    right: true,
    nowrap: true,
    onRender: item => (
      <Actions
        data={[{
          name: 'edit',
          onClick: () => {
            setEdit(item);
            setModal(true);
          },
        }]}
      />
    ),
  }];

  return (
    <>
      <div className={styles.menu}>
        <Menu onAdd={onOpenModal} />
      </div>
      <div className={styles.searchWrap}>
        <Input
          type="text"
          value={searchQuery}
          onChange={handleSearchChange}
          placeholder="Поиск по названию, адресу, коду ЖД, УНП"
        />
      </div>
      <div className={styles.table}>
        <Table
          cells={cells}
          data={items}
          count={count}
          page={page}
          limit={limit}
          onPageChange={({ selected }) => setPage(selected)}
          onLimitChange={(newLimit) => {
            setLimit(newLimit);
            setPage(0);
          }}
        />
      </div>
      {modal ? (
        <Modal closeBackground={false} onClose={onCloseModal}>
          <ConsigneeCatalog edit={edit} onClose={onCloseModal} />
        </Modal>
      ) : null}
    </>
  );
};

export default ConsigneeCatalogPage;
